import axios from '@/libs/http'

/**
 * 获取动态列表
 */
export const getPostList = (clerkId, status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/a/post/list',
        params: {
            clerkId,
            status,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 删除动态
 */
export const deletedPost = (postId) => {
    let data = new URLSearchParams()
    data.append("id", postId)
    return axios.request({
        url: '/s/a/post/delete',
        data,
        method: 'post'
    })
}

/**
 * 组长获取动态列表
 */
export const getClerkPostCheckList = (clerkId, status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/l/leader/clerkPostCheckList',
        params: {
            clerkId,
            status,
            pageNo,
            pageSize
        },
        method: 'post'
    })
}

/**
 * 会长获取动态列表
 */
export const getClerkPostList = (clerkId, status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/g/post/list',
        params: {
            clerkId,
            status,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 审核店员信息
 */
export const checkPost = (clerkPostCheckId, status, remark) => {
    return axios.request({
        url: '/s/clerkPostCheck/check',
        params: {
            clerkPostCheckId,
            status,
            remark
        },
        method: 'post'
    })
}
